var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpLeft = function SvgUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58818 5.04751C3.37664 4.83598 3.37664 4.49301 3.58818 4.28148C3.79971 4.06994 4.14267 4.06994 4.35421 4.28148L8.9504 8.87767C9.16194 9.08921 9.16194 9.43217 8.9504 9.6437C8.73887 9.85524 8.3959 9.85524 8.18437 9.6437L3.58818 5.04751Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18453 4.82314C8.48368 4.82314 8.7262 4.58063 8.7262 4.28147C8.7262 3.98232 8.48368 3.73981 8.18453 3.73981H3.58834C3.29833 3.73981 3.05978 3.96822 3.04718 4.25795L3.07071 8.66263C3.05771 8.9615 3.28946 9.21432 3.58834 9.22731C3.88721 9.24031 4.14003 9.00856 4.15302 8.70969L4.10696 4.82314H8.18453Z",
    fill: "currentcolor"
  })));
};
export default SvgUpLeft;